import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';

const AddOnsSection = ({ scrollToSection }) => {
  return (
    <section id="addons" className="py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <p className="text-rose-500 text-sm font-medium tracking-wider uppercase mb-2">Additional Services</p>
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-stone-800 mb-4">Add-Ons & Special Services</h2>
          <p className="text-stone-600 max-w-2xl mx-auto">Enhance your experience with our premium add-on services</p>
        </div>

        <div className="max-w-6xl mx-auto">
          <Accordion type="single" collapsible className="space-y-4">
            {/* Pre-Bridal Home Services */}
            <AccordionItem value="item-1" className="bg-rose-50 rounded-xl border border-rose-200 px-6 overflow-hidden">
              <AccordionTrigger className="text-xl font-semibold text-stone-800 hover:text-rose-500 transition-colors py-6">
                Pre-Bridal Home Services
              </AccordionTrigger>
              <AccordionContent>
                <div className="grid md:grid-cols-2 gap-4 pb-4">
                  <Card className="border-rose-100">
                    <CardContent className="p-4 flex justify-between items-center">
                      <div>
                        <p className="font-semibold text-stone-800">Manicure</p>
                      </div>
                      <div className="text-right">
                        <p className="text-2xl font-bold text-rose-500">₹1,000</p>
                        <Button onClick={() => scrollToSection('contact')} size="sm" className="mt-2 bg-rose-500 hover:bg-rose-600">Book</Button>
                      </div>
                    </CardContent>
                  </Card>
                  <Card className="border-rose-100">
                    <CardContent className="p-4 flex justify-between items-center">
                      <div>
                        <p className="font-semibold text-stone-800">Pedicure</p>
                      </div>
                      <div className="text-right">
                        <p className="text-2xl font-bold text-rose-500">₹1,000</p>
                        <Button onClick={() => scrollToSection('contact')} size="sm" className="mt-2 bg-rose-500 hover:bg-rose-600">Book</Button>
                      </div>
                    </CardContent>
                  </Card>
                  <Card className="border-rose-100">
                    <CardContent className="p-4 flex justify-between items-center">
                      <div>
                        <p className="font-semibold text-stone-800">Bridal Facial</p>
                        <p className="text-sm text-stone-600">Starting from</p>
                      </div>
                      <div className="text-right">
                        <p className="text-2xl font-bold text-rose-500">₹2,500</p>
                        <Button onClick={() => scrollToSection('contact')} size="sm" className="mt-2 bg-rose-500 hover:bg-rose-600">Book</Button>
                      </div>
                    </CardContent>
                  </Card>
                  <Card className="border-rose-100">
                    <CardContent className="p-4 flex justify-between items-center">
                      <div>
                        <p className="font-semibold text-stone-800">Clean-Up</p>
                        <p className="text-sm text-stone-600">Starting from</p>
                      </div>
                      <div className="text-right">
                        <p className="text-2xl font-bold text-rose-500">₹500</p>
                        <Button onClick={() => scrollToSection('contact')} size="sm" className="mt-2 bg-rose-500 hover:bg-rose-600">Book</Button>
                      </div>
                    </CardContent>
                  </Card>
                  <Card className="border-rose-100">
                    <CardContent className="p-4 flex justify-between items-center">
                      <div>
                        <p className="font-semibold text-stone-800">Full Body De-Tan</p>
                      </div>
                      <div className="text-right">
                        <p className="text-2xl font-bold text-rose-500">₹1,500</p>
                        <Button onClick={() => scrollToSection('contact')} size="sm" className="mt-2 bg-rose-500 hover:bg-rose-600">Book</Button>
                      </div>
                    </CardContent>
                  </Card>
                </div>
              </AccordionContent>
            </AccordionItem>

            {/* Waxing Services */}
            <AccordionItem value="item-2" className="bg-rose-50 rounded-xl border border-rose-200 px-6 overflow-hidden">
              <AccordionTrigger className="text-xl font-semibold text-stone-800 hover:text-rose-500 transition-colors py-6">
                Waxing (Normal / Rica Wax)
              </AccordionTrigger>
              <AccordionContent>
                <div className="grid md:grid-cols-3 gap-4 pb-4">
                  <Card className="border-rose-100">
                    <CardContent className="p-4">
                      <p className="font-semibold text-stone-800 mb-2">Hands</p>
                      <div className="space-y-2">
                        <div className="flex justify-between items-center">
                          <span className="text-stone-600 text-sm">Normal Wax</span>
                          <span className="font-bold text-rose-500">₹300</span>
                        </div>
                        <div className="flex justify-between items-center">
                          <span className="text-stone-600 text-sm">Rica Wax</span>
                          <span className="font-bold text-rose-500">₹500</span>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                  <Card className="border-rose-100">
                    <CardContent className="p-4">
                      <p className="font-semibold text-stone-800 mb-2">Half Legs</p>
                      <div className="space-y-2">
                        <div className="flex justify-between items-center">
                          <span className="text-stone-600 text-sm">Normal Wax</span>
                          <span className="font-bold text-rose-500">₹300</span>
                        </div>
                        <div className="flex justify-between items-center">
                          <span className="text-stone-600 text-sm">Rica Wax</span>
                          <span className="font-bold text-rose-500">₹500</span>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                  <Card className="border-rose-100">
                    <CardContent className="p-4">
                      <p className="font-semibold text-stone-800 mb-2">Full Legs</p>
                      <div className="space-y-2">
                        <div className="flex justify-between items-center">
                          <span className="text-stone-600 text-sm">Normal Wax</span>
                          <span className="font-bold text-rose-500">₹500</span>
                        </div>
                        <div className="flex justify-between items-center">
                          <span className="text-stone-600 text-sm">Rica Wax</span>
                          <span className="font-bold text-rose-500">₹700</span>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                  <Card className="border-rose-100">
                    <CardContent className="p-4">
                      <p className="font-semibold text-stone-800 mb-2">Underarms</p>
                      <div className="space-y-2">
                        <div className="flex justify-between items-center">
                          <span className="text-stone-600 text-sm">Normal Wax</span>
                          <span className="font-bold text-rose-500">₹100</span>
                        </div>
                        <div className="flex justify-between items-center">
                          <span className="text-stone-600 text-sm">Rica Wax</span>
                          <span className="font-bold text-rose-500">₹200</span>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                  <Card className="border-rose-100">
                    <CardContent className="p-4">
                      <p className="font-semibold text-stone-800 mb-2">Full Body Wax</p>
                      <div className="space-y-2">
                        <div className="flex justify-between items-center">
                          <span className="text-stone-600 text-sm">Normal Wax</span>
                          <span className="font-bold text-rose-500">₹1,500</span>
                        </div>
                        <div className="flex justify-between items-center">
                          <span className="text-stone-600 text-sm">Rica Wax</span>
                          <span className="font-bold text-rose-500">₹2,500</span>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                </div>
              </AccordionContent>
            </AccordionItem>

            {/* Hair Care Services */}
            <AccordionItem value="item-3" className="bg-rose-50 rounded-xl border border-rose-200 px-6 overflow-hidden">
              <AccordionTrigger className="text-xl font-semibold text-stone-800 hover:text-rose-500 transition-colors py-6">
                Hair Care Home Services
              </AccordionTrigger>
              <AccordionContent>
                <div className="grid md:grid-cols-2 gap-4 pb-4">
                  <Card className="border-rose-100">
                    <CardContent className="p-4 flex justify-between items-center">
                      <div>
                        <p className="font-semibold text-stone-800">Hair Cut</p>
                      </div>
                      <div className="text-right">
                        <p className="text-2xl font-bold text-rose-500">₹1,000</p>
                      </div>
                    </CardContent>
                  </Card>
                  <Card className="border-rose-100">
                    <CardContent className="p-4 flex justify-between items-center">
                      <div>
                        <p className="font-semibold text-stone-800">Hair Spa</p>
                        <p className="text-sm text-stone-600">Based on length & thickness</p>
                      </div>
                      <div className="text-right">
                        <p className="text-2xl font-bold text-rose-500">₹1,000+</p>
                      </div>
                    </CardContent>
                  </Card>
                  <Card className="border-rose-100">
                    <CardContent className="p-4 flex justify-between items-center">
                      <div>
                        <p className="font-semibold text-stone-800">Hair Color</p>
                        <p className="text-sm text-stone-600">Root Touch-up</p>
                      </div>
                      <div className="text-right">
                        <p className="text-2xl font-bold text-rose-500">₹1,600</p>
                      </div>
                    </CardContent>
                  </Card>
                  <Card className="border-rose-100">
                    <CardContent className="p-4 flex justify-between items-center">
                      <div>
                        <p className="font-semibold text-stone-800">Highlights</p>
                      </div>
                      <div className="text-right">
                        <p className="text-2xl font-bold text-rose-500">₹4,000+</p>
                      </div>
                    </CardContent>
                  </Card>
                  <Card className="border-rose-100">
                    <CardContent className="p-4 flex justify-between items-center">
                      <div>
                        <p className="font-semibold text-stone-800">Global Hair Color</p>
                      </div>
                      <div className="text-right">
                        <p className="text-2xl font-bold text-rose-500">₹3,500+</p>
                      </div>
                    </CardContent>
                  </Card>
                </div>
              </AccordionContent>
            </AccordionItem>

            {/* Bridal Outfit Styling */}
            <AccordionItem value="item-4" className="bg-rose-50 rounded-xl border border-rose-200 px-6 overflow-hidden">
              <AccordionTrigger className="text-xl font-semibold text-stone-800 hover:text-rose-500 transition-colors py-6">
                Bridal Outfit Styling
              </AccordionTrigger>
              <AccordionContent>
                <div className="pb-4 space-y-4">
                  <p className="text-stone-600 leading-relaxed">
                    Helping brides look stunning—right from the first selection to the final fitting. A personalized service designed for brides 
                    who want expert guidance while choosing their wedding wardrobe. Whether you're overwhelmed with options or simply short on time, 
                    I accompany you in person, helping you pick outfits that perfectly match your skin tone, body shape, personality, and wedding theme.
                  </p>
                  <div className="grid md:grid-cols-2 gap-4">
                    <Card className="border-rose-100">
                      <CardContent className="p-6">
                        <h4 className="font-semibold text-stone-800 mb-2">One City Styling</h4>
                        <p className="text-sm text-stone-600 mb-4">Includes store visits, selection assistance, and full day styling guidance</p>
                        <p className="text-3xl font-bold text-rose-500">₹20,000</p>
                      </CardContent>
                    </Card>
                    <Card className="border-rose-100">
                      <CardContent className="p-6">
                        <h4 className="font-semibold text-stone-800 mb-2">Two Cities Styling</h4>
                        <p className="text-sm text-stone-600 mb-4">For brides exploring designer wear in multiple cities</p>
                        <p className="text-3xl font-bold text-rose-500">₹30,000</p>
                      </CardContent>
                    </Card>
                  </div>
                </div>
              </AccordionContent>
            </AccordionItem>

            {/* Nail Art */}
            <AccordionItem value="item-5" className="bg-rose-50 rounded-xl border border-rose-200 px-6 overflow-hidden">
              <AccordionTrigger className="text-xl font-semibold text-stone-800 hover:text-rose-500 transition-colors py-6">
                Nail Art & Extensions
              </AccordionTrigger>
              <AccordionContent>
                <div className="pb-4">
                  <Card className="border-rose-100">
                    <CardContent className="p-6 flex justify-between items-center">
                      <div>
                        <p className="font-semibold text-stone-800">Hands & Feet Combo</p>
                        <p className="text-sm text-stone-600">Starting from</p>
                      </div>
                      <div className="text-right">
                        <p className="text-3xl font-bold text-rose-500">₹1,500</p>
                        <Button onClick={() => scrollToSection('contact')} size="sm" className="mt-2 bg-rose-500 hover:bg-rose-600">Book</Button>
                      </div>
                    </CardContent>
                  </Card>
                </div>
              </AccordionContent>
            </AccordionItem>
          </Accordion>

          <div className="mt-12 bg-rose-50 rounded-2xl p-6 border border-rose-200">
            <h3 className="text-lg font-semibold text-stone-800 mb-4">Important Notes:</h3>
            <ul className="space-y-2 text-stone-600">
              <li>• All services are provided by the trained team</li>
              <li>• Travel charges are applicable based on location</li>
              <li>• Advance appointment booking is mandatory</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AddOnsSection;